
import React from "react";
import { isEqual } from "lodash";
import MultiSelect from "components/Input/MultiSelect";
import Button from "components/Button";
import FilterStatus from "components/FilterStatus";
import classes from "./style.module.scss";
import FilterIcon from "assets/images/icons/Filter.svg";

const FiltersBar = React.memo(({
    multiSelectInputs = [],
    handleApply = () => {},
    handleClear = () => {},
    newFilter = false,
}) => {
    return (
        <div className={classes.filters}>
            <img src={FilterIcon} alt="filter" />
            {multiSelectInputs.map(({ label, options, selectedOpts, handleOptChange }) => (
                <MultiSelect
                    key={`${label}-filter`}
                    hideLabel
                    dropDownWidth="max-content"
                    customLabel={
                        <div className={classes.dropdownCustomLabel}>
                            {label}
                            <FilterStatus
                                numSelected={selectedOpts.length}
                                maxNumSelection={options.length}
                                noneLabel={"None"}
                            />
                        </div>
                    }
                    options={options}
                    input={{
                        value: selectedOpts,
                        onChange: (value) => handleOptChange(value),
                    }}
                    hasSelectAll
                    idPrefix={`${label}-filter`}
                />
            ))}
            <Button small disabled={!newFilter} onClick={handleApply}>
                Apply
            </Button>
            <Button small type="white" onClick={handleClear}>
                Clear
            </Button>
        </div>
    );
}, isEqual);

export default FiltersBar;